(function() {
	angular.module('ShargoApp')
		.controller('AboutUsController', function($scope, $rootScope, $window, $q, $timeout, deviceDetector, toolsService, Configuration){
			$rootScope.pageConfiguration = {
				footer: true,
				header: {
					solid: 200,
					background: 'linear-gradient(to bottom, #fed256, #ffbd4d)',
					preheader: false,
					headerLink: $rootScope.url('home'),
					headerLogo: $rootScope.device.isDesktop ? Configuration.siteDomain + "/img/header/shargo-white.svg" : Configuration.siteDomain + "/img/header/shargo-mobile.svg",
					logIn: true,
					dashboard: true,
					callToAction: {
						link: $rootScope.device.isDesktop ? $rootScope.url('sendpackage') : $rootScope.url('contact'),
						text: $rootScope.device.isDesktop ? 'header.ask4Shargo' : 'header.contact',
						target: '',
						hide: true,
						disabled: false
					},
					profile: true
				}
			};
			/* --DEFINITIONS-- */
			$scope.team = [
				{
					"title": "about-us.team.founders.title",
					"employers": [
						{
							"styleDefault":	{'background-image': "url('../img/team/pau-castle1.jpg')"},
							"styleHover":	{'background-image': "url('../img/team/pau-castle2.jpg')"},
							"name"		: 	"Pau Castillo",
							"title"		: 	"CEO"
						},
						{
							"styleDefault":	{'background-image': "url('../img/team/guillermo1.jpg')"},
							"styleHover":	{'background-image': "url('../img/team/guillermo2.jpg')"},
							"name": 		"Guillem Solé",
							"title": 		"CTO"
						},
						{
							"styleDefault":	{'background-image': "url('../img/team/pballard1.jpg')"},
							"styleHover":	{'background-image': "url('../img/team/pballard2.jpg')"},
							"name": 		"Pau Ballart",
							"title": 		"CPO"
						},
						{
							"styleDefault":	{'background-image': "url('../img/team/deivid1.jpg')"},
							"styleHover":	{'background-image': "url('../img/team/deivid2.jpg')"},
							"name"		: 	"David Castillo",
							"title"		: 	"CCO"
						},
						{
							"styleDefault":	{'background-image': "url('../img/team/eloi1.jpg')"},
							"styleHover":	{'background-image': "url('../img/team/eloi2.jpg')"},
							"name": 		"Eloi Urdangarin",
							"title": 		"CMO"
						}
					]
				},
				{
					"title": "about-us.team.operations.title",
					"employers": [
						{
							"styleDefault":	{'background-image': "url('../img/team/xvalls1.jpg')"},
							"styleHover":	{'background-image': "url('../img/team/xvalls2.jpg')"},
							"name": 		"Xavier Valls",
							"title": 		"Operations Director"
						},
						{
							"styleDefault":	{'background-image': "url('../img/team/mcity1.jpg')"},
							"styleHover":	{'background-image': "url('../img/team/mcity2.jpg')"},
							"name": 		"Marc Ciudad",
							"title": 		"City Manager"
						},
						{
							"styleDefault":	{'background-image': "url('../img/team/marta-operations1.jpg')"},
							"styleHover":	{'background-image': "url('../img/team/marta-operations2.jpg')"},
							"name": 		"Marta Pàmies",
							"title": 		"Operations Manager"
						},{
							"styleDefault":	{'background-image': "url('../img/team/enbodenbufa1.jpg')"},
							"styleHover":	{'background-image': "url('../img/team/enbodenbufa2.jpg')"},
							"name": 		"Albert Bofarull",
							"title": 		"Driver Acquisition"
						},
						{
							"styleDefault":	{'background-image': "url('../img/team/carlies1.jpg')"},
							"styleHover":	{'background-image': "url('../img/team/carlies2.jpg')"},
							"name": 		"Carles Miralpeix",
							"title": 		"Operations Manager"
						},
						{
							"styleDefault":	{'background-image': "url('../img/team/berni1.jpg')"},
							"styleHover":	{'background-image': "url('../img/team/berni2.jpg')"},
							"name": 		"Bernat Rocarols",
							"title": 		"Operations Manager"
						},{
							"styleDefault":	{'background-image': "url('../img/team/pablo1.jpg')"},
							"styleHover":	{'background-image': "url('../img/team/pablo2.jpg')"},
							"name": 		"Pablo Cantería",
							"title": 		"Operations Manager"
						}
					]
				},
				{
					"title": "about-us.team.development.title",
					"employers": [
						{
							"styleDefault":	{'background-image': "url('../img/team/ericson1.jpg')"},
							"styleHover":	{'background-image': "url('../img/team/ericson2.jpg')"},
							"name": 		"Eric Lara",
							"title": 		"Full Stack"
						},
						{
							"styleDefault":	{'background-image': "url('../img/team/martinez1.jpg')"},
							"styleHover":	{'background-image': "url('../img/team/martinez2.jpg')"},
							"name": 		"Martin Cristóbal",
							"title": 		"Data Analysis"
						},
						{
							"styleDefault":	{'background-image': "url('../img/team/dragos-society1.jpg')"},
							"styleHover":	{'background-image': "url('../img/team/dragos-society2.jpg')"},
							"name": 		"Dragos Fotescu",
							"title": 		"Back End"
						},
						{
							"styleDefault":	{'background-image': "url('../img/team/xconejo1.jpg')"},
							"styleHover":	{'background-image': "url('../img/team/xconejo2.jpg')"},
							"name": 		"Xavier Conejo",
							"title": 		"Front End"
						}
					]
				}
			];
		});
})();